import { Link } from "@reach/router";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { handleSummaryData, OrderSummaryData } from "../../services/services";
import { getCookieData } from "../../Store/GetData";
import sample from "../../assets/images/ableaura.svg";
import * as classes from "./Grouporder.module.scss";
import { navigate } from "gatsby";
import { FailureModalShow } from "../../Store/Action/Action";
import moment from "moment";

export default function OrderSummary() {
  const dispatch = useDispatch();
  const userdata = useSelector((state) => state.data);
  const [uniqueOrderIds, setUniqueOrderIds] = useState(new Set());
  const [summaryData, setSummaryData] = useState();

  const handleOrderSummary = () => {
    OrderSummaryData()
      .then((res) => {
        const uniqueIds = new Set();
        const uniqueSummaryData = res.data.data.filter((ele) => {
          const orderId = ele?.summary?.order_summary_id;
          const isSubscription = ele?.is_ecoms_subscription;

          if (isSubscription !== 1 && !uniqueIds.has(orderId)) {
            uniqueIds.add(orderId);
            return true;
          }
          return false;
        });
        setSummaryData(uniqueSummaryData);
        setUniqueOrderIds(uniqueIds);
      })
      .catch((err) => {
        dispatch(
          FailureModalShow({
            show: true,
            msg: err.message,
          })
        );
      });
  };

  useEffect(() => {
    handleOrderSummary();
  }, []);

  console.log(summaryData, "summaryData");

  return (
    <>
      <div className={classes.groupheading}>
        <h3 aria-level="1">Group Orders</h3>
      </div>
      {summaryData?.length !== 0 ? (
        <div className="mainsec">
          {summaryData?.map((ele) => (
            <div key={ele?.summary?.order_summary_id} className={classes.clubSec}>
              <div className={classes.imgoutline}>
                <img aria-hidden="true" src={sample} alt="" role="image" />
              </div>
              <h4 aria-level="2"> Summary ID: {ele?.summary?.order_summary_id}</h4>
              <p role="none">
                Order Date: {moment(ele?.summary?.created_at).format("DD-MM-YYYY")}
              </p>
              <p>Price: {ele?.summary?.total}</p>
              <div
                className={`btnoutline ${classes.btn}`}
                onClick={() => {
                  navigate("/Orders/list", {
                    state: { ...ele, isEdit: true },
                  });
                }}
                role="button"
                tabIndex="0"
              >
                <div className={`SubmitBtn ${classes.SubmitBtn}`} tabIndex="0">
                  VIEW ORDER
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="mainsec">
          <div className="noResultsSec mt-10 mb-20 pt-20">
            <h3>No Order found</h3>
          </div>
        </div>
      )}
    </>
  );
}


